import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import user from './modules/user';
import pub from './modules/common';
import project from './modules/project';
import datalogger from './modules/datalogger';
import sensor from './modules/sensor';
import pointEx from './modules/pointEx';
import report from './modules/report';
import test from './modules/test';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {

  },
  modules: {
    app,
    user,
    pub,
    project,
    datalogger,
    sensor,
    pointEx,
    report,
    test
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js